export enum CareOfEnum {
  Self = 1,
  Caregiver = 2,
  Physician = 3
}

export const CareOfOptions = [
{ id: 1, label: 'Self' },
{ id: 2, label: 'Caregiver' },
{ id: 3, label: 'Physician' }
];
